import { FORTA_BLACK } from '../../../utils/colors';

import type { SxProps, Theme } from '@mui/material/styles';

/**
 * Absolutely-positioned outline that draws the field border with a notch for the floating label —
 * a hand-rolled equivalent of MUI's `NotchedOutline` fieldset. The `<legend>` auto-sizes the gap
 * to the label text, so no background fill is needed to hide the border behind the label. Painted
 * over the picker (last sibling) so the border is not covered by an opaque input fill.
 */
export const NOTCHED_FIELDSET_SX: SxProps<Theme> = {
  textAlign: 'left',
  position: 'absolute',
  inset: '-5px 0 0 0',
  margin: 0,
  padding: '0 8px',
  pointerEvents: 'none',
  borderRadius: '6px',
  borderStyle: 'solid',
  borderWidth: '1px',
  borderColor: FORTA_BLACK,
  overflow: 'hidden',
  minWidth: '0%',
};

export const NOTCHED_FIELDSET_LEGEND_SX: SxProps<Theme> = {
  float: 'unset',
  width: 'auto',
  overflow: 'hidden',
  display: 'block',
  padding: 0,
  height: 11,
  // Match the visible label exactly (native 0.75rem) so the notch is the same width as the label.
  fontSize: '0.75rem',
  visibility: 'hidden',
  maxWidth: '100%',
  whiteSpace: 'nowrap',
  '& > span': {
    px: '5px',
    display: 'inline-block',
    opacity: 0,
    visibility: 'visible',
  },
};
